import { render, staticRenderFns } from "./ShipsPiPSC.vue?vue&type=template&id=12eed000&scoped=true&"
import script from "./ShipsPiPSC.vue?vue&type=script&lang=js&"
export * from "./ShipsPiPSC.vue?vue&type=script&lang=js&"
import style0 from "./ShipsPiPSC.vue?vue&type=style&index=0&id=12eed000&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eed000",
  null
  
)

export default component.exports